import DirectoryPage from "./DirectoryPage";
export default function Coaches() {
  return <DirectoryPage role="coach" eyebrow="Coaches" title="National Coach Registry" subtitle="Federation-certified coaches with verifiable licenses and experience." />;
}
